module.exports = __webpack_public_path__ + "static/p17-f098f29c53aab3e6d8e5174882be3918.jpg";